import React from 'react';
import PropTypes, { checkPropTypes } from 'prop-types';
import { IconButton, Icon } from '@sumtotal/react-foundation';
import styled from 'styled-components';
import { postMessage } from '../../../modules/core/services/coreIFrameHelper';
import useUserContext from '../../hooks/useUserContext';

const HelpIconButton = styled(IconButton)`
  padding: 0.425rem 0.3rem;
  color: ${(props) => props.theme.variables.headerBarColor};
  &.Mui-disabled {
    color: ${(props) => props.theme.variables.headerBarColor};
    opacity: 0.5;
  }
  &:focus {
    background-color: ${(props) => props.theme.variables.leftNavHeaderBackground};
    outline: -webkit-focus-ring-color auto 0.0625rem;
  }
`;

function Help(props) {
  const { helpMenu = defaultProps.helpMenu } = props;
  checkPropTypes(Help.propTypes, props, 'prop', Help.name);
  const { user } = useUserContext();
  const disableHelpIcon = !user.isEmulatedUser ? user.mustAnswerSecurityQuestions : false;
  function onHelpClick() {
    postMessage('OPEN_HELP', null, false, null, false, true);
  }
  return (
    <HelpIconButton
      onClick={() => onHelpClick()}
      size="small"
      color="inherit"
      label={helpMenu.name}
      disabled={disableHelpIcon}
    >
      <Icon iconType="MaterialIcon" iconName="HelpOutline" size={1.75} />
    </HelpIconButton>
  );
}

// PropType check
Help.propTypes = {
  /**
   * Help SitemapNode
   */
  helpMenu: PropTypes.oneOfType([PropTypes.object])
};

const defaultProps = {
  helpMenu: {}
};

export default Help;
